import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const baseUrl =
  process.env.REACT_APP_BACKEND_BASE_URL || "http://localhost:5000";

// ================= IMAGE HELPER =================
const getImageUrl = (user) => {
  if (!user?.profilePic) {
    const fallback = `${baseUrl}/uploads/businesses/default.png`;

    return fallback;
  }

  if (user.profilePic.startsWith("http")) {
    console.log("🌐 Already full URL:", user.profilePic);
    return user.profilePic;
  }

  const finalUrl = `${baseUrl}/${user.profilePic}`;
  console.log("🛠️ Generated image URL:", finalUrl);

  return finalUrl;
};

// ================= THUNK =================
export const fetchRegisteredUsers = createAsyncThunk(
  "users/fetchRegisteredUsers",
  async (category = "All", thunkAPI) => {
    try {
      const response = await axios.get(
        `${baseUrl}/business/searchBusinessUsers`,
      );

      const data = response.data;

      let users = [];

      if (Array.isArray(data.users)) {
        users = data.users;
      } else if (Array.isArray(data)) {
        users = data;
      } else {
        throw new Error("Unexpected response format");
      }

      // ================= FILTER =================
      if (category && category !== "All") {
        users = users.filter((user) => {
          const match =
            user.categoryPath?.[0]?.toLowerCase() === category.toLowerCase();

          return match;
        });
      }

      // ================= IMAGE MAP =================
      users = users.map((user) => {
        const updated = {
          ...user,
          profilePic: getImageUrl(user),
        };

        return updated;
      });

      return users;
    } catch (error) {
      console.error("❌ Fetch Registered Users Error:", error);

      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message,
      );
    }
  },
);

// ================= SLICE =================
const usersSlice = createSlice({
  name: "users",
  initialState: {
    registeredUsers: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchRegisteredUsers.pending, (state) => {
        console.log("⏳ Loading users...");
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRegisteredUsers.fulfilled, (state, action) => {
       
        state.loading = false;
        state.registeredUsers = action.payload;
      })
      .addCase(fetchRegisteredUsers.rejected, (state, action) => {
        console.log("❌ Users fetch failed:", action.payload);
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default usersSlice.reducer;
